// Get Campaigns

import Campaigns from '@/services/Campaigns'
export default {
    data() {
        return {
            campaigns: []
        }
    },
    methods: {
        getCampaigns() {
             Campaigns.get().then(res => {
                this.campaigns = res.data
             })
         },
    }
}